import PartialTickCircle from '@/modules/corporate/modules/quiz/views/QuizPlayer/views/QuizPlayerReview/components/icons/PartialTickCircle';

function PartiallyCorrectIcon({
  className,
  fillColorToken,
}: {
  className?: string;
  fillColorToken?: string;
}) {
  return <PartialTickCircle className={className} strokeColorToken={fillColorToken} />;
}

export default PartiallyCorrectIcon;
